import { Tbody } from '@chakra-ui/react';
import { Row } from './Row';

export function ListLayout({ list, handleSelectLayout, selectedLayouts }) {
  return (
    <Tbody>
      {list?.map((item, index) => (
        <Row
          key={item.id}
          index={index}
          item={item}
          handleSelectLayout={handleSelectLayout}
          selectedLayouts={selectedLayouts}
          selectedId={selectedLayouts.map((layout) => layout.id)}
        />
      ))}
    </Tbody>
  );
}
